/* eslint-disable no-shadow */
// Tradutor
import i18n from "@/i18n";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import DateFormatter from "@/constants/date-format/DateFormatter";

import {
	SET_EVENT_TABLE,
	SET_EVENT_TABLE_ERROR,
	SET_EVENT_TABLE_SUCCESS,
	OPEN_DIALOG_EVENTS,
	CLOSE_DIALOG_EVENTS,
} from "@/stores/actions/EventsTable";

const headers = [
	{
		text:     i18n.t("TableHeaders.Date"),
		value:    "date",
		class:    [ "secondary--text", "px-2", "primary" ],
		align:    "start",
		sortable: true,
	},
	{
		text:     i18n.t("TableHeaders.Description"),
		value:    "description",
		class:    [ "secondary--text", "px-2", "primary" ],
		align:    "start",
		sortable: false,
	},
];

/**
* @summary Atribui os eventos a tabela.
* @type {function}
* @param {Array[Object]} eventsRecords - eventos.
* @param {Array[Object]} eventsSettings  Configurações dos Eventos
* @return {Array[Object]} Itens da tabela de eventos.
*/
const SetDataTable = (eventsRecords = [], eventsSettings = []) =>
{
	const eventsDataTable = [];

	for (let i = 0; i < eventsRecords.length; i++)
	{
		for (let j = 0; j < eventsSettings.length; j++)
		{
			const event = { date: "", description: "" };
			if (eventsRecords[i].eventSettingId === eventsSettings[j].id)
			{
				event.date = DateFormatter.ToDDMMYYYYHHMMSS(eventsRecords[i].dateTime);
				event.description = eventsSettings[j].name;
				eventsDataTable.push(event);
			}
		}
	}
	return eventsDataTable;
};

const state = {
	dialogEvents: false,
	events:       [],
	headers,
	status:       FetchStatus.Init,
	error:        {},
};

const actions = {

	[OPEN_DIALOG_EVENTS]: ({ commit }) =>
	{
		commit(OPEN_DIALOG_EVENTS);
	},

	[CLOSE_DIALOG_EVENTS]: ({ commit }) =>
	{
		commit(CLOSE_DIALOG_EVENTS);
	},

	[SET_EVENT_TABLE]: ({ commit }, resp) =>
	{
		commit(SET_EVENT_TABLE);
		try
		{
			const tableItems = SetDataTable(resp.eventsRecords, resp.eventsSettings);
			commit(SET_EVENT_TABLE_SUCCESS, tableItems);
		}
		catch (error)
		{
			commit(SET_EVENT_TABLE_ERROR);
		}
	},
};

const mutations = {
	[OPEN_DIALOG_EVENTS]: (state) =>
	{
		state.dialogEvents = true;
	},
	[CLOSE_DIALOG_EVENTS]: (state) =>
	{
		state.dialogEvents = false;
	},
	[SET_EVENT_TABLE]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[SET_EVENT_TABLE_SUCCESS]: (state, resp) =>
	{
		state.events = resp;
		state.status = FetchStatus.Loaded;
	},
	[SET_EVENT_TABLE_ERROR]: (state, error) =>
	{
		state.error = error;
	},
};

export default {
	state,
	actions,
	mutations,
};
